import { checkEmptyFields } from '../utils';
import { EventProperties } from '@lentau/analytics/health-metrics/shared';
import { FavoriteItem } from './types';
import { ProductsDataProps, ProductType } from '@lentau/product/shared/interfaces';
import { ResponseCommentRateDto } from '@lentau/order/feedback/store/shared/interfaces';

export function getProductHandler(body: ProductsDataProps): EventProperties {
  {
    const items: ProductType[] = body.GoodsItemList;

    const fields = items
      .map((item: ProductType) => {
        return [
          {
            fieldToCheck: item.Name,
            errorName: 'productNameEmpty',
          },
          {
            fieldToCheck: item.Images,
            errorName: 'productImagesEmpty',
          },
        ];
      })
      .flat();

    return checkEmptyFields(fields);
  }
}

export function getCarouselHandler(body: ProductsDataProps): EventProperties {
  {
    const items: ProductType[] = body.GoodsItemList;

    const fields = [
      {
        fieldToCheck: items,
        errorName: 'productCarouselEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function favoriteItemAddHandler(body: { FavoriteItemList: FavoriteItem[] }): EventProperties {
  {
    const item: FavoriteItem = body.FavoriteItemList[0];

    const fields = [
      {
        fieldToCheck: item.Id,
        errorName: 'favoriteItemAddEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function commentRateHandler(body: ResponseCommentRateDto): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: body.result,
        errorName: 'commentRateEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}
